import axios from '@/lib/axios'
import { useQuery } from '@tanstack/vue-query'
import { type Ref, computed, unref } from 'vue'

import { CustomAxiosRequestConfig } from '@/interfaces/customAxiosRequestConfig'

/**
 * Fetches enriched flight request data from our database.
 * Use this for display (airport names, airline logos, tickets, segments,
 * tax breakdowns, penalties).
 *
 * GET /api/requests/{id} — internal request ID, NOT provider PNR.
 * For provider PNR data (Sabre), use useFlightReservation.
 */
export default function useFlightRequestDetail(
	requestId: Ref<number | null | undefined> | number | null
) {
	const id = computed(() => {
		const val = unref(requestId)
		return val ?? null
	})

	return useQuery({
		queryKey: ['flight-request-detail', id],
		queryFn: async () => {
			// errorHandling: false → un requestId stale/ajeno (403/404) falla la
			// query localmente en vez de redirigir vía el interceptor global.
			const { data } = await axios.get(`/api/requests/${id.value}`, {
				errorHandling: false,
			} as CustomAxiosRequestConfig)
			return data.data ?? data
		},
		enabled: computed(() => id.value !== null && id.value > 0),
		refetchOnWindowFocus: false,
		// 5 min de caché: evita refetch al volver al tab sin quedar obsoleto
		staleTime: 5 * 60 * 1000,
	})
}
